import type { PropsWithChildren } from "react";
import { SkipToMainContentLink } from "./SkipToMainContentLink";
import { StandardLayout } from "./StandardLayout";

export function Layout({ children }: PropsWithChildren) {
  return (
    <>
      <SkipToMainContentLink />
      <StandardLayout>{children}</StandardLayout>
    </>
  );
}
